import { capitalizeFirstLetter } from '.';

export const getNameAndSurname = (username: string) =>
  username.split('.').map(capitalizeFirstLetter).join(' ');
